<div fxLayout="row mt-5" class="container" fxFlex="100" fxLayoutAlign="space-between" [formGroup]="formGroup">
  <!-- First column -->
  <div class="column" fxLayout="column" fxFlex="24">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'FirstName' | translate }}</mat-label>
      <input matInput type="text" formControlName="firstName" tabindex="1" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'Location' | translate }}</mat-label>
      <input matInput formControlName="location" placeholder="{{ 'Location' | translate }}" [matAutocomplete]="autocompleteLocation" tabindex="5" />
      <mat-autocomplete #autocompleteLocation="matAutocomplete" [displayWith]="displayValue">
        @for (location of locations$ | async; track location) {
          <mat-option [value]="location">
            {{ location.Name }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'WTL-IsInternshipAgreement' | translate }}</mat-label>
      <mat-select formControlName="isInternshipAgreement" tabindex="9">
        <mat-option></mat-option>
        <mat-option [value]="true">{{ 'Yes' | translate }}</mat-option>
        <mat-option [value]="false">{{ 'No' | translate }}</mat-option>
      </mat-select>
    </mat-form-field>

    @if (isApprovedByExternalWorker) {
      <mat-form-field appearance="outline">
        <mat-label>{{ 'WTL-IsApprovedByExternalEmployee' | translate }}</mat-label>
        <mat-select formControlName="isApprovedByExternalWorker" tabindex="13">
          <mat-option></mat-option>
          <mat-option [value]="true">{{ 'Yes' | translate }}</mat-option>
          <mat-option [value]="false">{{ 'No' | translate }}</mat-option>
        </mat-select>
      </mat-form-field>
    }
  </div>

  <!-- Second column -->
  <div class="column" fxLayout="column" fxFlex="24">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'LastName' | translate }}</mat-label>
      <input matInput type="text" formControlName="lastName" tabindex="2" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'Employer' | translate }}</mat-label>
      <input matInput formControlName="employer" placeholder="{{ 'Employer' | translate }}" [matAutocomplete]="autocompleteEmployer" tabindex="6" />
      <mat-autocomplete #autocompleteEmployer="matAutocomplete" [displayWith]="displayValue">
        @for (employer of employers$ | async; track employer) {
          <mat-option [value]="employer">
            {{ employer.Name }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'Settlement-Status' | translate }}</mat-label>
      <mat-select formControlName="isSettled" tabindex="10">
        <mat-option></mat-option>
        <mat-option [value]="true">{{ 'Settled' | translate }}</mat-option>
        <mat-option [value]="false">{{ 'ToBeSettled' | translate }}</mat-option>
      </mat-select>
    </mat-form-field>

    <ng-container *hasPermission="isSentToExteralSystemPermissions">
      @if (isToBeSettledListType) {
        <mat-form-field appearance="outline">
          <mat-label>{{ 'WTL-IsSentToExteralSystem' | translate }}</mat-label>
          <mat-select formControlName="timesheetSyncStatusId" multiple tabindex="8">
            @for (timesheetSyncStatus of timesheetSyncStatuses$ | async; track timesheetSyncStatus) {
              <mat-option [value]="timesheetSyncStatus.Id">
                {{ timesheetSyncStatus.Name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    </ng-container>
  </div>

  <!-- Third column -->
  <div class="column" fxLayout="column" fxFlex="24">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'Pesel' | translate }}</mat-label>
      <input matInput type="text" formControlName="pesel" tabindex="3" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'EmployerObject' | translate }}</mat-label>
      <input
        matInput
        formControlName="employerObject"
        placeholder="{{ 'EmployerObject' | translate }}"
        [matAutocomplete]="autocompleteEmployerObject"
        tabindex="7"
        />
        <mat-autocomplete #autocompleteEmployerObject="matAutocomplete" [displayWith]="displayValue">
          @for (employerObject of employerObjects$ | async; track employerObject) {
            <mat-option [value]="employerObject">
              {{ employerObject.Name }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'WTL-IsApprovedByEmployee' | translate }}</mat-label>
        <mat-select formControlName="isApprovedByWorker" tabindex="11">
          <mat-option></mat-option>
          <mat-option [value]="true">{{ 'Yes' | translate }}</mat-option>
          <mat-option [value]="false">{{ 'No' | translate }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="column" fxLayout="column" fxFlex="24">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'Passport' | translate }}</mat-label>
        <input matInput type="text" formControlName="document" appAlphanumeric tabindex="4" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'MPK' | translate }}</mat-label>
        <input matInput placeholder="{{ 'MPK' | translate }}" formControlName="mpk" tabindex="8" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ 'WTL-IsApprovedByInternalEmployee' | translate }}</mat-label>
        <mat-select formControlName="isApprovedByInternalWorker" tabindex="12">
          <mat-option></mat-option>
          <mat-option [value]="true">{{ 'Yes' | translate }}</mat-option>
          <mat-option [value]="false">{{ 'No' | translate }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
